/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiRegionV1Id } from '../fn/region/delete-api-region-v-1-id';
import { DeleteApiRegionV1Id$Params } from '../fn/region/delete-api-region-v-1-id';
import { getApiRegionV1Id$Json } from '../fn/region/get-api-region-v-1-id-json';
import { GetApiRegionV1Id$Json$Params } from '../fn/region/get-api-region-v-1-id-json';
import { getApiRegionV1Id$Plain } from '../fn/region/get-api-region-v-1-id-plain';
import { GetApiRegionV1Id$Plain$Params } from '../fn/region/get-api-region-v-1-id-plain';
import { postApiRegionV1Getall$Json } from '../fn/region/post-api-region-v-1-getall-json';
import { PostApiRegionV1Getall$Json$Params } from '../fn/region/post-api-region-v-1-getall-json';
import { postApiRegionV1Getall$Plain } from '../fn/region/post-api-region-v-1-getall-plain';
import { PostApiRegionV1Getall$Plain$Params } from '../fn/region/post-api-region-v-1-getall-plain';
import { postApiRegionV1Regions$Json } from '../fn/region/post-api-region-v-1-regions-json';
import { PostApiRegionV1Regions$Json$Params } from '../fn/region/post-api-region-v-1-regions-json';
import { postApiRegionV1Regions$Plain } from '../fn/region/post-api-region-v-1-regions-plain';
import { PostApiRegionV1Regions$Plain$Params } from '../fn/region/post-api-region-v-1-regions-plain';
import { putApiRegionV1Id$Json } from '../fn/region/put-api-region-v-1-id-json';
import { PutApiRegionV1Id$Json$Params } from '../fn/region/put-api-region-v-1-id-json';
import { putApiRegionV1Id$Plain } from '../fn/region/put-api-region-v-1-id-plain';
import { PutApiRegionV1Id$Plain$Params } from '../fn/region/put-api-region-v-1-id-plain';
import { RegionModel } from '../models/region-model';

@Injectable({ providedIn: 'root' })
export class RegionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiRegionV1Id()` */
  static readonly GetApiRegionV1IdPath = '/private/v1/regions/{id}';

  /**
   * Retrieves a Region by its unique identifier.
   *
   * Retrieves a Region by its unique identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiRegionV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRegionV1Id$Plain$Response(params: GetApiRegionV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
    return getApiRegionV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Region by its unique identifier.
   *
   * Retrieves a Region by its unique identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiRegionV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRegionV1Id$Plain(params: GetApiRegionV1Id$Plain$Params, context?: HttpContext): Observable<RegionModel> {
    return this.getApiRegionV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegionModel>): RegionModel => r.body)
    );
  }

  /**
   * Retrieves a Region by its unique identifier.
   *
   * Retrieves a Region by its unique identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiRegionV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRegionV1Id$Json$Response(params: GetApiRegionV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
    return getApiRegionV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Region by its unique identifier.
   *
   * Retrieves a Region by its unique identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiRegionV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRegionV1Id$Json(params: GetApiRegionV1Id$Json$Params, context?: HttpContext): Observable<RegionModel> {
    return this.getApiRegionV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegionModel>): RegionModel => r.body)
    );
  }

  /** Path part for operation `putApiRegionV1Id()` */
  static readonly PutApiRegionV1IdPath = '/private/v1/regions/{id}';

  /**
   * Updates an existing Region.
   *
   * Updates an existing Region.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiRegionV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRegionV1Id$Plain$Response(params: PutApiRegionV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
    return putApiRegionV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Region.
   *
   * Updates an existing Region.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiRegionV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRegionV1Id$Plain(params: PutApiRegionV1Id$Plain$Params, context?: HttpContext): Observable<RegionModel> {
    return this.putApiRegionV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegionModel>): RegionModel => r.body)
    );
  }

  /**
   * Updates an existing Region.
   *
   * Updates an existing Region.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiRegionV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRegionV1Id$Json$Response(params: PutApiRegionV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
    return putApiRegionV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Region.
   *
   * Updates an existing Region.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiRegionV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRegionV1Id$Json(params: PutApiRegionV1Id$Json$Params, context?: HttpContext): Observable<RegionModel> {
    return this.putApiRegionV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegionModel>): RegionModel => r.body)
    );
  }

  /** Path part for operation `deleteApiRegionV1Id()` */
  static readonly DeleteApiRegionV1IdPath = '/private/v1/regions/{id}';

  /**
   * Deletes a Region by its unique identifier.
   *
   * Deletes a Region by its unique identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiRegionV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiRegionV1Id$Response(params: DeleteApiRegionV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiRegionV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Region by its unique identifier.
   *
   * Deletes a Region by its unique identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiRegionV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiRegionV1Id(params: DeleteApiRegionV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiRegionV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiRegionV1Regions()` */
  static readonly PostApiRegionV1RegionsPath = '/private/v1/regions/create';

  /**
   * Creates a new Region.
   *
   * Creates a new Region.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRegionV1Regions$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Regions$Plain$Response(params?: PostApiRegionV1Regions$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
    return postApiRegionV1Regions$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Region.
   *
   * Creates a new Region.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRegionV1Regions$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Regions$Plain(params?: PostApiRegionV1Regions$Plain$Params, context?: HttpContext): Observable<RegionModel> {
    return this.postApiRegionV1Regions$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegionModel>): RegionModel => r.body)
    );
  }

  /**
   * Creates a new Region.
   *
   * Creates a new Region.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRegionV1Regions$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Regions$Json$Response(params?: PostApiRegionV1Regions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
    return postApiRegionV1Regions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Region.
   *
   * Creates a new Region.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRegionV1Regions$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Regions$Json(params?: PostApiRegionV1Regions$Json$Params, context?: HttpContext): Observable<RegionModel> {
    return this.postApiRegionV1Regions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegionModel>): RegionModel => r.body)
    );
  }

  /** Path part for operation `postApiRegionV1Getall()` */
  static readonly PostApiRegionV1GetallPath = '/private/v1/regions';

  /**
   * Retrieves the list of all available  Regions.
   *
   * Retrieves the list of all available  Regions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRegionV1Getall$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Getall$Plain$Response(params?: PostApiRegionV1Getall$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegionModel>>> {
    return postApiRegionV1Getall$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available  Regions.
   *
   * Retrieves the list of all available  Regions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRegionV1Getall$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Getall$Plain(params?: PostApiRegionV1Getall$Plain$Params, context?: HttpContext): Observable<Array<RegionModel>> {
    return this.postApiRegionV1Getall$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RegionModel>>): Array<RegionModel> => r.body)
    );
  }

  /**
   * Retrieves the list of all available  Regions.
   *
   * Retrieves the list of all available  Regions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRegionV1Getall$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Getall$Json$Response(params?: PostApiRegionV1Getall$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegionModel>>> {
    return postApiRegionV1Getall$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available  Regions.
   *
   * Retrieves the list of all available  Regions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRegionV1Getall$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRegionV1Getall$Json(params?: PostApiRegionV1Getall$Json$Params, context?: HttpContext): Observable<Array<RegionModel>> {
    return this.postApiRegionV1Getall$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RegionModel>>): Array<RegionModel> => r.body)
    );
  }

}
